import { createAsyncThunk } from "@reduxjs/toolkit";
import messageService from "../../../api/services/message";

export const createMessage = createAsyncThunk(
  "message/create-message",
  async (requestData) => {
    return await messageService.createMessage(requestData);
  }
);
